export { CorporativoOnboardingCardIdRegional } from "./CorporativoOnboardingCardIdRegional";
